import React, { useEffect, useState } from 'react';
import useEsami from '../../hooks/useEsami';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/it';
import CustomCalendar from '../../components/CustomCalendar/CustomCalendar';
import CustomModal from '../../components/CustomModal/CustomModal';
import { Button, Alert, Badge, Card, Table } from 'react-bootstrap';
import ComebackArrow from '../../components/ComebackArrow/ComebackArrow';
import CardLoadingPage from '../../components/CardLoadingPage/CardLoadingPage';
import useEsamiUtenti from '../../hooks/useEsamiUtenti';
import EsamiUtentiService from '../../services/EsamiUtentiService/EsamiUtentiService';
import { alertService } from '../../services/AlertService';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';
import useMediaQuery from '../../hooks/useMediaQuery';
import CustomButton from '../../components/CustomButton/CustomButton';
import { TIPO_CORSO } from '../../model/tipoCorso';

export default function AreaPersonaleEsamiPage() {
  const { getEsamiByClasseAndByToken, loadingStateEsami, getEsamiByIdClasse, getAllEsamiByIdClasse } = useEsami();
  const { prenotaEsameCorsoSincrono, loadingStateEsamiUtenti, prenotaEsameCorsoAsincrono, deleteEsameUtente, enterJoinroomCorsista } = useEsamiUtenti();
  const location = useLocation();
  const classe = location.state?.classeData;
  const [exams, setExams] = useState([]);
  const [selectedExam, setSelectedExam] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [bookingStep, setBookingStep] = useState('initial');
  const userLoggedIn = useSelector(state => state?.user?.userData);
  const isSmallScreen = useMediaQuery('(max-width: 1024px)');
  const [examCountdowns, setExamCountdowns] = useState({});

  useEffect(() => {
    if (classe?.id_classe) {
      if (userLoggedIn?.role === ROLES.TUTOR) {
        fetchEsamiForTutor();
      } else {
        if (classe?.corso?.modalita_erogazione !== TIPO_CORSO.TELEMATICA_ASINCRONA) {
          fetchGetEsamiByClasseAndByToken({ id_classe: classe.id_classe });
        } else {
          fetchAllEsamiByIdClasse({ id_classe: classe.id_classe });
        }
      }
    }
  }, [classe]);

  useEffect(() => {
    moment.locale('it');
  }, []);

  const fetchGetEsamiByClasseAndByToken = async (classId) => {
    let response = await getEsamiByClasseAndByToken(classId);
    if (Array.isArray(response)) {
      setExams(response.map(exam => ({
        ...exam,
        start: new Date(`${exam.data.split(' ')[0]}T${exam.ora_inizio}`),
        end: new Date(`${exam.data.split(' ')[0]}T${exam.ora_fine}`),
        myPrenotation: exam.prenotato
      })));
    }
  };

  const fetchAllEsamiByIdClasse = async (classId) => {
      const [resEsamiByClasseAndByToken, resAllEsamiByIdClasse] = await Promise.all([
        getEsamiByClasseAndByToken(classId),
        getAllEsamiByIdClasse(classId)
      ]);

      if (Array.isArray(resAllEsamiByIdClasse) && Array.isArray(resEsamiByClasseAndByToken)) {
        setExams(resAllEsamiByIdClasse.concat(resEsamiByClasseAndByToken).map(exam => ({
          ...exam,
          start: new Date(`${exam.data.split(' ')[0]}T${exam.ora_inizio}`),
          end: new Date(`${exam.data.split(' ')[0]}T${exam.ora_fine}`),
          myPrenotation: exam.prenotato
        }))); 
      }
  };

  const fetchEsamiForTutor = async () => {
      const response = await getEsamiByIdClasse({ id_classe: classe.id_classe });
      if (Array.isArray(response)) {
        setExams(response.map(exam => ({
          ...exam,
          start: new Date(`${exam.data.split(' ')[0]}T${exam.ora_inizio}`),
          end: new Date(`${exam.data.split(' ')[0]}T${exam.ora_fine}`),
          title: `Esame (${exam.utenti.filter(u => u.prenotato).length}/${exam.utenti.length} prenotati)`
        })));
      }
  };

  const handleSelectEvent = (event) => {
    setSelectedExam(event);
    setShowModal(true);
    setBookingStep('initial');
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedExam(null);
    setBookingStep('initial');
  };

  const handleBookExam = () => {
    setBookingStep('confirm');
  };

  const handleConfirmBooking = async () => {
    try {
      let response;
      if(classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) { 
        response = await prenotaEsameCorsoAsincrono({ id_calendario_esame: selectedExam.id_calendario_esame, id_classe_utente: classe.id_classe_utente });
      } else {
        response = await prenotaEsameCorsoSincrono({ id_calendario_esame: selectedExam.id_calendario_esame, id_classe_utente: classe.id_classe_utente });
      }
  
      if (response) {
        if (classe?.corso?.modalita_erogazione !== TIPO_CORSO.TELEMATICA_ASINCRONA) {
          await fetchGetEsamiByClasseAndByToken({ id_classe: classe.id_classe });
        } else {
          await fetchAllEsamiByIdClasse({ id_classe: classe.id_classe });
        }
        setBookingStep('success');
      }
    } catch (error) {
      alertService.error('Errore durante la prenotazione.');
    }
  };

  const openCancelModal = () => {
    setShowCancelModal(true);
  };
  
  const confirmCancelBooking = async () => {
    try {
      await deleteEsameUtente({
        id_esame_utente: selectedExam.id_calendario_esame_utente
      });
  
      if (classe?.corso?.modalita_erogazione !== TIPO_CORSO.TELEMATICA_ASINCRONA) {
        await fetchGetEsamiByClasseAndByToken({ id_classe: classe.id_classe });
      } else {
        await fetchAllEsamiByIdClasse({ id_classe: classe.id_classe });
      }
  
      alertService.success("Prenotazione annullata con successo.", { autoClose: true });
      setShowModal(false);
      setShowCancelModal(false); // Chiudi anche la modale di conferma
    } catch (error) {
      alertService.error('Errore durante l\'annullamento della prenotazione.');
    }
  };

  const minDate = classe?.data_fine ? moment(classe.data_fine).toDate() : new Date();

  const customEventPropGetter = (event) => {
    let style = {
      backgroundColor: '#3174ad',
      color: 'white'
    };

    if (event.prenotato) {
      if (event.presenza === 'assente') {
        style.backgroundColor = '#dc3545';
      } else if (event.esito_esame) {
        if (event.esito_esame === 'promosso') {
          style.backgroundColor = '#28a745';
        } else if (event.esito_esame === 'bocciato') {
          style.backgroundColor = '#ffc107';
          style.color = 'black';
        }
      } else {
        style.backgroundColor = '#3174ad';
      }
    }

    return { style };
  };

  useEffect(() => {
    updateCountdowns(); // chiamata iniziale
    const interval = setInterval(() => {
      updateCountdowns();
    }, 1000);
  
    return () => clearInterval(interval);
  }, [exams]);

  const updateCountdowns = () => {
    const now = moment();
    const updatedCountdowns = {};
  
    exams.forEach(exam => {
      if (exam.prenotato === true || exam.myPrenotation === 1) {
        const start = moment(exam.start);
        const diffSeconds = start.diff(now, 'seconds');
  
        if (diffSeconds <= 0) {
          updatedCountdowns[exam.id_calendario_esame] = 'INIZIATO';
        } else if (diffSeconds <= 86400) { // solo se mancano meno di 24 ore
          if (diffSeconds < 60) {
            updatedCountdowns[exam.id_calendario_esame] = `Inizio tra ${diffSeconds} second${diffSeconds === 1 ? 'o' : 'i'}`;
          } else if (diffSeconds < 3600) {
            const minutes = Math.floor(diffSeconds / 60);
            updatedCountdowns[exam.id_calendario_esame] = `Inizio tra ${minutes} minut${minutes === 1 ? 'o' : 'i'}`;
          } else {
            const duration = moment.duration(start.diff(now));
            const hours = duration.hours();
            const minutes = duration.minutes();
            updatedCountdowns[exam.id_calendario_esame] = `Inizio tra ${hours} or${hours === 1 ? 'a' : 'e'} e ${minutes} minut${minutes === 1 ? 'o' : 'i'}`;
          }
        }
      }
    });
  
    setExamCountdowns(prev => {
      // Interrompi aggiornamenti quando un esame è INIZIATO
      const changed = Object.keys(updatedCountdowns).some(
        key => updatedCountdowns[key] !== prev[key]
      );
      return changed ? updatedCountdowns : prev;
    });
  };

  const enterJoinRoom = async (id_calendario_esame) => {
    try {
      let response;
      response = await enterJoinroomCorsista({ id_calendario_esame: id_calendario_esame, id_classe_utente: classe.id_classe_utente });
      var meeting_id = response[0].meeting_id;
      var enc_str = response[0].enc_str;
      if(meeting_id.length > 0){
          var redirect = 'https://www.jampink.com/jp-meeting/'+ meeting_id+'?se='+enc_str;
          window.location = redirect;
      }
    } catch (error) {
      alertService.error('Errore durante l\'accesso alla Joinroom di esame.');
    }
  };

  if (loadingStateEsami.isLoadingEsamiByClasseAndByToken) {
    return <CardLoadingPage />;
  }

  const renderModalContent = () => {
    if (!selectedExam) return null;

    if (userLoggedIn?.role === ROLES.TUTOR) {
      return (
        <div>
          <h4>Dettagli Esame</h4>
          <p>Data: {moment(selectedExam.start).format('DD/MM/YYYY')}</p>
          <p>Orario: {moment(selectedExam.start).format('HH:mm')} - {moment(selectedExam.end).format('HH:mm')}</p>
          <h5>Partecipanti:</h5>
          {isSmallScreen ? (
            <div>
              {selectedExam.utenti?.map(utente => (
                <Card key={utente.id_utente} className="mb-3">
                  <Card.Body>
                    <Card.Title>{utente.nome} {utente.cognome}</Card.Title>
                    <Card.Text>
                      <strong>Stato Prenotazione:</strong> {utente.prenotato ? 'Prenotato' : 'Non prenotato'}<br/>
                      <strong>Presenza:</strong> {
                        utente.presenza === 'presente' ? 'Presente' :
                        utente.presenza === 'assente' ? 'Assente' :
                        'Non registrata'
                      }<br/>
                      <strong>Esito:</strong> {utente.esito_esame?.replace('_', ' ') || 'Non svolto'}<br/>
                      <strong>Voto:</strong> {utente.voto || '-'}
                    </Card.Text>
                  </Card.Body>
                </Card>
              ))}
            </div>
          ) : (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Cognome</th>
                  <th>Stato Prenotazione</th>
                  <th>Presenza</th>
                  <th>Esito</th>
                  <th>Voto</th>
                </tr>
              </thead>
              <tbody>
                {selectedExam.utenti?.map(utente => (
                  <tr key={utente.id_utente}>
                    <td>{utente.nome}</td>
                    <td>{utente.cognome}</td>
                    <td>{utente.prenotato ? 'Prenotato' : 'Non prenotato'}</td>
                    <td>
                      {utente.presenza === 'presente' ? 'Presente' :
                       utente.presenza === 'assente' ? 'Assente' :
                       'Non registrata'}
                    </td>
                    <td>{utente.esito_esame?.replace('_', ' ') || 'Non svolto'}</td>
                    <td>{utente.voto || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      );
    }

    const renderExamResult = () => {
      if (selectedExam.presenza === 'assente') {
        return (
          <Alert variant="danger">
            <Alert.Heading><i className="bi bi-exclamation-triangle me-2"></i>Assente all'esame</Alert.Heading>
            <p>Non hai partecipato a questo esame.</p>
            {selectedExam.note && (
              <>
              <hr />
              <p className="mb-0"><strong>Note:</strong> {selectedExam.note}</p>
              </>
            )}
          </Alert>
        );
      } else if (selectedExam.esito_esame && selectedExam.esito_esame !== 'non_svolto') {
        const isPromosso = selectedExam.esito_esame === 'promosso';
        return (
          <Card className={`border-${isPromosso ? 'success' : 'warning'} mb-3`}>
            <Card.Header className={`bg-${isPromosso ? 'success' : 'warning'} ${isPromosso ? 'text-white' : 'text-dark'}`}>
              <h5 className="mb-0">
                {isPromosso ? (
                  <><i className="bi bi-check-circle me-2"></i> Esame Superato</>
                ) : (
                  <><i className="bi bi-x-circle me-2"></i> Esame Non Superato</>
                )}
              </h5>
            </Card.Header>
            <Card.Body>
              <Card.Title>
                Esito: <span>{selectedExam.esito_esame.charAt(0).toUpperCase() + selectedExam.esito_esame.slice(1)}</span>
              </Card.Title>
              {selectedExam.voto && (
                <Card.Text>
                  <strong>Voto:</strong> <span className="fs-4">{selectedExam.voto}</span>
                </Card.Text>
              )}
              {selectedExam.note && (
                <Card.Text>
                  <strong>Note:</strong> {selectedExam.note}
                </Card.Text>
              )}
              {selectedExam.statino_presente && (
                <Button 
                  variant="outline-primary" 
                  onClick={() => handleDownloadStatino(selectedExam.id_calendario_esame_utente, selectedExam?.nome_file_statino)}
                  className="mt-2"
                >
                  <i className="bi bi-download me-2"></i> Scarica Statino
                </Button>
              )}
            </Card.Body>
          </Card>
        );
      }
      return null;
    };

    const handleDownloadStatino = async (idCalendarioEsameUtente, filename) => {
      try {
        await EsamiUtentiService.downloadStatino({ id_calendario_esame_utente: idCalendarioEsameUtente, filename: filename });
      } catch (error) {
        alertService.error('Errore nel download dello statino');
      }
    };

    switch (bookingStep) {
      case 'initial':
        return (
          <div className="exam-details">
            <h4 className="mb-4">Dettagli Esame</h4>
            <p><strong>Data:</strong> {moment(selectedExam.start).format('dddd D MMMM YYYY')}</p>
            <p><strong>Orario:</strong> {moment(selectedExam.start).format('HH:mm')} - {moment(selectedExam.end).format('HH:mm')}</p>
            {selectedExam.prenotato ? (
              <>
                <p><strong>Data Prenotazione:</strong> {moment(selectedExam.data_prenotazione).format('DD/MM/YYYY HH:mm')}</p>
                {moment(selectedExam.start).diff(moment(), 'hours') >= 24 ? (
                  <>
                    <p className="text-muted" style={{ fontSize: '0.9rem' }}>
                      Puoi annullare la tua prenotazione fino a 24 ore prima dell'inizio dell'esame.
                    </p>
                    <Button 
                      variant="danger" 
                      className="mt-3"
                      onClick={openCancelModal}
                    >
                      Annulla Prenotazione
                    </Button>
                  </>
                ) : (
                  <p className="text-danger" style={{ fontSize: '0.9rem' }}>
                    Non è possibile annullare la tua prenotazione all'esame.
                  </p>
                )}
                {renderExamResult()}
              </>
            ) : (
              <Button 
                variant="primary" 
                onClick={handleBookExam} 
                className="mt-3"
                disabled={loadingStateEsamiUtenti.isLoadingEsameUtenteCreating}
              >
                Prenota Esame
              </Button>
            )}
          </div>
        );
      case 'confirm':
        return (
          <div className="exam-confirmation">
            <h4 className="mb-4">Conferma Prenotazione</h4>
            <p>Sei sicuro di voler prenotare l'esame per il giorno {moment(selectedExam.start).format('DD/MM/YYYY')} dalle {moment(selectedExam.start).format('HH:mm')} alle {moment(selectedExam.end).format('HH:mm')}?</p>
            <div className="d-flex justify-content-between mt-4">
              <Button variant="secondary" onClick={() => setBookingStep('initial')}>
                Indietro
              </Button>
              <CustomButton 
                variant="success"
                label={'Conferma Prenotazione'}
                isLoading={loadingStateEsamiUtenti.isLoadingEsameUtentePrenotazione}
                onClick={handleConfirmBooking}
                disabled={loadingStateEsamiUtenti.isLoadingEsameUtenteCreating}
              />
            </div>
          </div>
        );
      case 'success':
        return (
          <div className="exam-success">
            <Alert variant="success" className="mb-4">
              <h4 className="alert-heading">Prenotazione Confermata!</h4>
              <p>Hai prenotato con successo l'esame per il giorno {moment(selectedExam.start).format('DD/MM/YYYY')} dalle {moment(selectedExam.start).format('HH:mm')} alle {moment(selectedExam.end).format('HH:mm')}.</p>
            </Alert>
            <Button variant="primary" onClick={handleCloseModal}>
              Chiudi
            </Button>
          </div>
        );
      default:
        return null;
    }
  };

  const getBackPath = () => {
    if (userLoggedIn?.role === ROLES.TUTOR) {
      return "/area-personale/classi"
    } else {
      if (classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
        return "/area-personale/corso"
      } else {
        return "/area-personale/classe"
      }
    }
  }

  const examsPrenotati = exams.filter(exam => exam.prenotato === true);
  const examsPrenotatiFromDB = exams.filter(exam => exam.myPrenotation === 1);
  const userHasPrenotato = examsPrenotati.length > 0;
  const userHasPrenotatoFromDB = examsPrenotatiFromDB.length > 0;

  return (
    <div className={`card custom-card w-100 shadow ${isSmallScreen ? 'py-3 px-0' : 'p-5'}`} style={{ minHeight: "700px" }}>
      <div className="container">
        <ComebackArrow path={getBackPath()} state={{ classe }} />
        <div className="d-flex justify-content-between custom-card-header mb-3">
          <div className="d-flex gap-3 custom-card-title my-2">
            <div className="custom-icon-container">
              {classe?.corso?.immagine_corso ? 
                <img src={classe?.corso?.immagine_corso} className='custom-icon' alt='immagine corso'/> : 
                <i className="bi custom-icon bi-calendar-event fs-2"></i>}
            </div>
            <div className="align-self-center">
              <span className="fs-4 d-block">
                <i><b><h2>{classe?.corso?.denominazione} - Esami</h2></b></i>
              </span>
            </div>
          </div>
        </div>
        <div style={{ height: '100vh' }}>
        <CustomCalendar
          events={
            exams.length === 0 
              ? []
              : exams
                  .filter(exam => {
                    const hoursToExam = moment(exam.start).diff(moment(), 'hours');

                    if (userLoggedIn?.role !== ROLES.TUTOR) {
                      if (userHasPrenotato) {
                        return exam.prenotato === true;
                      }
                      else if (userHasPrenotatoFromDB) {
                        return exam.myPrenotation === 1;
                      }
                      return hoursToExam >= 24;
                    }

                    return true;
                  })
                  .map(exam => {
                    let baseTitle = "Esame Disponibile";
                    if (userLoggedIn?.role !== ROLES.TUTOR && (exam.prenotato === true || exam.myPrenotation === 1)) {
                      if (exam.presenza === 'assente') {
                        baseTitle = "Assente";
                      } else if (exam.esito_esame && exam.esito_esame !== 'non_svolto') {
                        baseTitle = exam.esito_esame === 'promosso' ? "Promosso" : "Bocciato";
                      } else {
                        baseTitle = "Esame Prenotato";
                      }
                    } else if (userLoggedIn?.role === ROLES.TUTOR) {
                      baseTitle = `Esame (${exam.utenti?.filter(u => u.prenotato)?.length || 0}/${exam.utenti?.length || 0} prenotati)`;
                    }

                    const countdownText = examCountdowns[exam.id_calendario_esame];
                    let subtitle = null;

                    const isExamBooked = exam.prenotato === true || exam.myPrenotation === 1;
                    const hasNotStarted = countdownText && countdownText !== 'INIZIATO';
                    const isAlreadyTaken = exam.esito_esame !== 'non_svolto';

                    if (isExamBooked && countdownText) {
                      if (countdownText === 'INIZIATO' && !isAlreadyTaken) {
                        subtitle = (
                          <Button
                            variant="success"
                            size="sm"
                            className="mt-2 fw-bold d-inline-flex align-items-center"
                            onClick={(e) => {
                              e.stopPropagation();
                              enterJoinRoom(exam.id_calendario_esame);
                            }}
                          >
                            <i className="bi bi-camera-video-fill me-2 fs-5"></i>
                            Accedi
                          </Button>
                        );
                      } else if (hasNotStarted) {
                        subtitle = <div className="text-muted small">{countdownText}</div>;
                      }
                    }

                    return {
                      ...exam,
                      title: (
                        <div>
                          <strong>{baseTitle}</strong>
                          {subtitle && <div>{subtitle}</div>}
                        </div>
                      )
                    };
                  })
          }
          availableViews={["agenda"]}
          customToolbar={() => (
            <div className="rbc-toolbar d-flex justify-content-center">
              <h4 className="text-primary">Esami disponibili</h4>
            </div>
          )}
          onSelectEvent={handleSelectEvent}
          eventCursor="pointer"
          slotCursor="default"
          minDate={minDate}
          maxDate={null}
          selectable={false}
          customEventPropGetter={customEventPropGetter}
        />

          {/* <CustomCalendar
            events={exams.map(exam => {
              let title = userLoggedIn?.role === ROLES.TUTOR
                ? `Esame (${exam.utenti.filter(u => u.prenotato).length}/${exam.utenti.length} prenotati)`
                : "Esame Disponibile";

              if (userLoggedIn?.role !== ROLES.TUTOR && exam.prenotato) {
                if (exam.presenza === 'assente') {
                  title = "Assente";
                } else if (exam.esito_esame && exam.esito_esame !== 'non_svolto') {
                  title = exam.esito_esame === 'promosso' ? "Promosso" : "Bocciato";
                } else {
                  title = "Esame Prenotato";
                }
              }

              return {
                ...exam,
                title,
              };
            })}
            onSelectEvent={handleSelectEvent}
            eventCursor="pointer"
            slotCursor="default"
            minDate={minDate}
            maxDate={null}
            selectable={false}
            customEventPropGetter={customEventPropGetter}
          /> */}
        </div>
        <CustomModal
          show={showModal}
          onHide={handleCloseModal}
          headerText={
            <h5 className="form-control-static">
              {selectedExam && moment(selectedExam.start).format('dddd D MMMM YYYY')}
            </h5>
          }
          size={userLoggedIn?.role === ROLES.TUTOR ? "xl" : "md"}
          body={renderModalContent()}
          btnCancelText="Chiudi"
          closeButton={true}
          hideButtons={true}
        />
        <CustomModal
          show={showCancelModal}
          onHide={() => setShowCancelModal(false)}
          headerText="Conferma Annullamento Prenotazione"
          body={
            <p className="mb-0">Sei sicuro di voler annullare la tua prenotazione?</p>
          }
          onSave={confirmCancelBooking}
          onUndoChanges={() => setShowCancelModal(false)}
          btnText="Conferma Annullamento"
          btnCancelText="Annulla"
          variant="danger"
          size="md"
          hideSaveBtn={false}
          closeButton={true}
        />
      </div>
    </div>
  );
}
